import { InstantAnswerContext } from "../types";

export const getShipFromCountryForOrder = (context: InstantAnswerContext) => {
  return context.brandOrder?.brand_order?.ship_from_address?.country;
};
